<template>
  <div>
    <v-row no-gutters align="center">
      <v-col cols="11">
        <v-row justify="end" align="center">
          <div v-if="syslog.length === 4">
            <span class="grey--text subtitle-2 text-center">
              {{ $tc('max_targets') }}
            </span>
          </div>
        </v-row>
      </v-col>

      <v-col cols="1">
        <v-row no-gutters justify="end">
          <v-tooltip bottom>
            <template #activator="{ on }">
              <v-btn icon v-on="on" @click="refreshData">
                <v-icon>
                  autorenew
                </v-icon>
              </v-btn>
            </template>
            <span>
              {{ $tc('refresh') }}
            </span>
          </v-tooltip>

          <v-tooltip bottom>
            <template #activator="{ on }">
              <v-btn
                icon
                :disabled="syslog.length === 4"
                v-on="on"
                @click="openAddModal"
              >
                <v-icon>
                  add
                </v-icon>
              </v-btn>
            </template>
            <span>
              {{ $tc('add_ip') }}
            </span>
          </v-tooltip>
        </v-row>
      </v-col>
    </v-row>

    <v-card flat class="rounded-lg mb-8" outlined style="background: transparent;">
      <syslog-table @deleteIp="openIpDeleteModal" />
    </v-card>

    <new-syslog-modal
      :open="showAddModal"
      @close="closeAddModal"
    />

    <syslog-delete-modal
      :ip="addr"
      :open="showIpDeleteModal"
      @close="closeIpDeleteModal"
    />
  </div>
</template>

<script>
import SyslogDeleteModal from './SyslogDeleteModal.vue'
import NewSyslogModal from './NewSyslogModal.vue'
import SyslogTable from './SyslogTable.vue'

export default {
  components: {
    SyslogTable,
    NewSyslogModal,
    SyslogDeleteModal
  },
  data () {
    return {
      status: false,
      showAddModal: false,
      addr: '',
      showIpDeleteModal: false
    }
  },
  computed: {
    syslog () {
      return this.$store.state.hsm.netInfo.syslog
    }
  },
  methods: {
    loadDate () {
      this.$store.dispatch('hsm/getNetInfo')
    },
    openAddModal () {
      this.showAddModal = true
    },
    closeAddModal () {
      this.loadDate()
      this.showAddModal = false
    },
    openIpDeleteModal (item) {
      this.addr = item.ip
      this.showIpDeleteModal = true
    },
    closeIpDeleteModal () {
      this.loadDate()
      this.showIpDeleteModal = false
    },
    refreshData () {
      this.loadDate()
    }
  }
}
</script>
